import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Jumbo } from "../../components/jumbo";
const React = require("react");
import { Loader } from "../loader";
const draftToHtml = require("draftjs-to-html");
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
export const ManagementLayout = (props)=>{
    const { reactions, submitting, validationMessages, updateStatus, acceptAll } = props;
    const blogTitles = reactions.kind == "loaded" ? new Set(reactions.value.map((r)=>r.blogPostTitle)) : new Set();
    return /*#__PURE__*/ _jsxs("div", {
        className: "management-page",
        children: [
            /*#__PURE__*/ _jsx(Jumbo, {
                title: "Beheer",
                contents: "Hier kun je alle blog reacties beheren.",
                imageUrl: "",
                imageUrlFallback: "",
                imageUrlLarge: "",
                imageAlt: "",
                size: "small"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "content",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "container",
                    children: [
                        validationMessages.length > 0 && /*#__PURE__*/ _jsx("div", {
                            className: "brf__errors",
                            role: "alert",
                            children: validationMessages.map((m, i)=>/*#__PURE__*/ _jsx("p", {
                                    className: `${m.kind == "error" ? "brf__error form__error" : ""} text--xs`,
                                    children: m.message
                                }, 'message-' + i))
                        }),
                        reactions.kind == "loaded" ? /*#__PURE__*/ _jsx(_Fragment, {
                            children: reactions.value.length == 0 ? /*#__PURE__*/ _jsx("p", {
                                children: "Er zijn op dit moment geen reacties met een onbeheerde status."
                            }) : Array.from(blogTitles).map((blogTitle)=>{
                                const blogReactions = reactions.value.filter((r)=>r.blogPostTitle == blogTitle);
                                return blogReactions.length == 0 ? /*#__PURE__*/ _jsx(_Fragment, {}) : /*#__PURE__*/ _jsxs(React.Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx("h3", {
                                            children: blogTitle
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "table-container",
                                            children: /*#__PURE__*/ _jsxs("table", {
                                                className: "text--s responsive",
                                                children: [
                                                    /*#__PURE__*/ _jsx("thead", {
                                                        children: /*#__PURE__*/ _jsxs("tr", {
                                                            children: [
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    className: "table--th--250",
                                                                    children: "Auteur"
                                                                }),
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    children: "Bericht"
                                                                }),
                                                                /*#__PURE__*/ _jsx("th", {
                                                                    className: "table--th--250"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("tbody", {
                                                        children: [
                                                            blogReactions.map((r)=>/*#__PURE__*/ _jsxs("tr", {
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("td", {
                                                                            children: [
                                                                                r.name,
                                                                                /*#__PURE__*/ _jsx("br", {}),
                                                                                /*#__PURE__*/ _jsxs("p", {
                                                                                    className: "text--xxs",
                                                                                    children: [
                                                                                        r.email,
                                                                                        /*#__PURE__*/ _jsx("br", {}),
                                                                                        /*#__PURE__*/ _jsx("time", {
                                                                                            dateTime: r.createdDate.toISOString(),
                                                                                            children: r.createdDate.format('D MMM YYYY')
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("td", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: draftToHtml(convertToRaw(EditorState.createWithContent(convertFromRaw(JSON.parse(r.body))).getCurrentContent()))
                                                                                }
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("td", {
                                                                            children: [
                                                                                /*#__PURE__*/ _jsx("button", {
                                                                                    disabled: submitting,
                                                                                    onClick: ()=>updateStatus(r.id, "accepted"),
                                                                                    className: "button button--primary",
                                                                                    children: "Approve"
                                                                                }),
                                                                                /*#__PURE__*/ _jsx("button", {
                                                                                    disabled: submitting,
                                                                                    onClick: ()=>updateStatus(r.id, "rejected"),
                                                                                    className: "button button--tertiary",
                                                                                    children: "Deny"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }, `reaction-${r.id}`)),
                                                            /*#__PURE__*/ _jsxs("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("td", {
                                                                        colSpan: 2
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("td", {
                                                                        children: /*#__PURE__*/ _jsx("button", {
                                                                            disabled: submitting,
                                                                            onClick: ()=>acceptAll(blogReactions.map((r)=>r.id)),
                                                                            className: "button button--primary",
                                                                            children: "Approve all"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, "BlogPost_" + blogTitle);
                            })
                        }) : /*#__PURE__*/ _jsx(Loader, {})
                    ]
                })
            })
        ]
    }, "ManagementLayout");
};
